import React from "react";

const fmt = (n) =>
  n == null
    ? "—"
    : Number(n).toLocaleString();

function Delta({
  pct,
  isLoss = false,
}) {
  if (pct == null) return null;

  const up = pct >= 0;

  return (
    <div
      className={`text-sm mt-2 flex items-center gap-1 ${
        isLoss
          ? "text-[#ff7b7b]"
          : up
          ? "text-[#ff7b7b]"
          : "text-[#7ee0a8]"
      }`}
    >
      <span>
        {up ? "▲" : "▼"}
      </span>

      <span>
        {Math.abs(pct).toFixed(1)}%
      </span>
    </div>
  );
}

function Card({
  label,
  value,
  unit,
  delta,
  dateLabel,
  isLoss = false,
}) {
  return (
    <div className="bg-[#132742] border border-[#23446f] rounded-xl p-4 min-h-[100px]">

      {/* LABEL */}
      <div className="text-[10px] uppercase tracking-wider text-[#7ea6d9] mb-1">
        {label}
      </div>

      {/* VALUE */}
      <div className="flex items-end gap-1">
        <div
          className={`text-[18px] font-semibold leading-none ${
            isLoss
              ? "text-[#ffb14a]"
              : "text-[#1998f0]"
          }`}
        >
          {fmt(value)}
        </div>

        <div className="text-[#8ba1c7] text-sm mb-1">
          {unit}
        </div>
      </div>

      {/* DELTA */}
      {delta != null && (
        <Delta
          pct={delta}
          isLoss={isLoss}
        />
      )}

      {/* DATE */}
      {dateLabel && (
        <div className="text-[#8ba1c7] text-sm mt-2">
          {dateLabel}
        </div>
      )}
    </div>
  );
}

export default function KPIStrip({
  mode = "district",
  data = {},
}) {
  if (mode === "filtered") {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
       <Card
  label="Recycled Water"
  value={data.recycledWater?.value}
  unit="gal"
  delta={data.recycledWater?.deltaPct}
/>

<Card
  label="Non Potable"
  value={data.nonPotable?.value}
  unit="gal"
  delta={data.nonPotable?.deltaPct}
/>

<Card
  label="Potable Domestic"
  value={data.potableDomestic?.value}
  unit="gal"
  delta={data.potableDomestic?.deltaPct}
/>

<Card
  label="Irrigation"
  value={data.irrigation?.value}
  unit="gal"
  delta={data.irrigation?.deltaPct}
/>

<Card
  label="Fire Flow"
  value={data.fireFlow?.value}
  unit="gal"
  delta={data.fireFlow?.deltaPct}
/>

<Card
  label="Interconnect"
  value={data.interconnect?.value}
  unit="gal"
  delta={data.interconnect?.deltaPct}
/>

<Card
  label="Active Meters"
  value={data.activeMeters?.value}
  unit=""
  delta={data.activeMeters?.deltaPct}
/>

<Card
  label="Inactive Meters"
  value={data.inactiveMeters?.value}
  unit=""
  delta={data.inactiveMeters?.deltaPct}
/>

<Card
  label="Avg Pressure"
  value={data.avgPressure?.value}
  unit="psi"
  delta={data.avgPressure?.deltaPct}
/>

<Card
  label="Leakage Rate"
  value={data.leakageRate?.value}
  unit="%"
  delta={data.leakageRate?.deltaPct}
/>
      </div>
    );
  }

  // DISTRICT MODE

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4 mt-4">

      <Card
        label="Supply"
        value={data.supply?.value}
        unit="gal"
        delta={
          data.supply?.deltaPct
        }
      />

      <Card
        label="Demand"
        value={data.demand?.value}
        unit="gal"
        delta={
          data.demand?.deltaPct
        }
      />

      <Card
        label="Loss"
        value={data.loss?.value}
        unit="gal"
        delta={
          data.loss?.deltaPct
        }
        isLoss
      />

      <Card
        label="Avg Daily"
        value={
          data.avgDaily?.value
        }
        unit="gal/d"
        delta={
          data.avgDaily?.deltaPct
        }
      />

      <Card
        label="Peak Day"
        value={data.peak?.value}
        unit="gal"
        dateLabel={
          data.peak?.dateLabel
        }
      />
    </div>
  );
}